import { useEffect, useRef } from 'react';

/**
 * Global cursor-following tooltip. Any element (including SVG shapes) that carries
 * a `data-t="title||detail"` attribute gets one — same contract as the source dashboard.
 */
export default function HoverTip() {
  const ref = useRef(null);

  useEffect(() => {
    const tip = ref.current;
    if (!tip) return;

    const move = (e) => {
      const pad = 12;
      let x = e.clientX + pad;
      let y = e.clientY + pad;
      const r = tip.getBoundingClientRect();
      if (x + r.width > window.innerWidth) x = e.clientX - r.width - pad;
      if (y + r.height > window.innerHeight) y = e.clientY - r.height - pad;
      tip.style.left = x + 'px';
      tip.style.top = y + 'px';
    };

    const onMove = (e) => {
      const t = e.target.closest?.('[data-t]');
      if (!t) return;
      const [a, b] = t.getAttribute('data-t').split('||');
      tip.innerHTML = `<b>${a}</b><br>${b || ''}`;
      tip.style.opacity = 1;
      move(e);
    };

    const onOut = (e) => {
      if (e.target.closest?.('[data-t]')) tip.style.opacity = 0;
    };

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseout', onOut);
    return () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseout', onOut);
    };
  }, []);

  return <div className="tip" ref={ref} />;
}

/** Imperative handle for charts that build their own rich tooltip markup. */
export const tipApi = {
  show(html, e) {
    const tip = document.querySelector('.tip');
    if (!tip) return;
    tip.innerHTML = html;
    tip.style.opacity = 1;
    const pad = 12;
    let x = e.clientX + pad;
    let y = e.clientY + pad;
    const r = tip.getBoundingClientRect();
    if (x + r.width > window.innerWidth) x = e.clientX - r.width - pad;
    if (y + r.height > window.innerHeight) y = e.clientY - r.height - pad;
    tip.style.left = x + 'px';
    tip.style.top = y + 'px';
  },
  hide() {
    const tip = document.querySelector('.tip');
    if (tip) tip.style.opacity = 0;
  },
};
